var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcecIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 9.37956H22.1667C22.7855 9.37956 23.379 9.62539 23.8166 10.063C24.2542 10.5006 24.5 11.0941 24.5 11.7129V18.7129C24.5 19.3317 24.2542 19.9252 23.8166 20.3628C23.379 20.8004 22.7855 21.0462 22.1667 21.0462H19.8333V25.7129L15.1667 21.0462H10.5C10.1936 21.0465 9.89006 20.9863 9.60696 20.869C9.32385 20.7517 9.06672 20.5796 8.85033 20.3626M8.85033 20.3626L12.8333 16.3796H17.5C18.1188 16.3796 18.7123 16.1337 19.1499 15.6961C19.5875 15.2586 19.8333 14.6651 19.8333 14.0462V7.04622C19.8333 6.42739 19.5875 5.83389 19.1499 5.39631C18.7123 4.95872 18.1188 4.71289 17.5 4.71289H5.83333C5.21449 4.71289 4.621 4.95872 4.18342 5.39631C3.74583 5.83389 3.5 6.42739 3.5 7.04622V14.0462C3.5 14.6651 3.74583 15.2586 4.18342 15.6961C4.621 16.1337 5.21449 16.3796 5.83333 16.3796H8.16667V21.0462L8.85033 20.3626Z",
    stroke: "#FDFBFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcecIcon);
export default __webpack_public_path__ + "static/media/ecec-icon.a663ac0c40fbd40c2d2760dac781f340.svg";
export { ForwardRef as ReactComponent };